"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Boosterpumpsolutions() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="3508" id="boosterpumpsolutions" className="bg-background text-foreground py-24 md:py-32 lg:py-40 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-5xl mx-auto">
        <div ref={header.ref} className={`transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-sans text-sm font-bold uppercase tracking-[0.2em] mb-10 md:mb-14 text-primary">
            OUR SOLUTIONS
          </p>
          <h2 className="font-default font-extrabold leading-[1.05] tracking-tight text-foreground text-[44px] sm:text-[56px] md:text-[64px] mb-12">
            Our Booster Pump <span className="text-primary">Solutions</span>
          </h2>
          
          <div className="pl-6 md:pl-10 border-l-4 border-accent">
            <p className="font-sans text-xl md:text-2xl font-light text-foreground/90 leading-relaxed max-w-4xl">
              AA Eagle Plumbing installs, repairs, replaces, and services booster pump systems for commercial and residential properties throughout the Miami Metro area. Whether pressure is dropping on upper floors, cycling unpredictably, or the pump has stopped altogether, we diagnose the problem and get the system running right.
            </p>
          </div>
        </div>
      </div>
    </section>;
}